'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _detail = require('./detail.component');

var _detail2 = _interopRequireDefault(_detail);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var detailModule = _angular2.default.module('detail', [_angularUiRouter2.default]).config(function ($stateProvider) {
  "ngInject";

  $stateProvider.state('dashboard.detail', {
    url: '/detail/:modelName/:id',
    component: 'detail',
    params: {
      id: null,
      modelType: null,
      modelName: null
    }
  });
}).component('detail', _detail2.default).name;

exports.default = detailModule;


// WEBPACK FOOTER //
// ./client/app/components/dashboard/detail/detail.js